import React from 'react';
import PropTypes from 'prop-types';

import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import './styles.css';
import BasicInput from '../../../BasicInput';

const InputFileRow = props => {
  const { value, isValid, index, onRemove, onChange, showDescription } = props;

  const handleChangeDescription = e => {
    onChange &&
      typeof onChange === 'function' &&
      onChange(index, { ...value, description: e.target.value });
  };

  const handleRemove = () => {
    onRemove && typeof onRemove === 'function' && onRemove(index);
  };

  const cls = `input-file-row${!isValid && ' input-file-row--invalid'}`;

  return (
    <div className={cls}>
      <div className="input-file-row__fields">
        <div
          className={
            showDescription
              ? 'input-file-row__field'
              : 'input-file-row__field input-file-row__field--fluid'
          }
        >
          <div className="input-file-row__block">
            <div className="input-file-row__name">File Name</div>
            <div className="input-file-row__value">{value.file.name}</div>
          </div>
        </div>

        <div className="input-file-row__field input-file-row__field--size">
          <div className="input-file-row__block">
            <div className="input-file-row__name">File Size</div>
            <div className="input-file-row__value">
              {(value.file.size / 1024).toFixed(1)}KB
            </div>
          </div>
        </div>

        {showDescription && (
          <div className="input-file-row__field">
            <div className="input-file-row__block">
              <div className="input-file-row__name">Description</div>
              <div className="input-file-row__value" style={{ width: '100%' }}>
                <BasicInput
                  name="Subject"
                  inputType="text"
                  content={value.description}
                  placeholder="Type here..."
                  controlFunc={handleChangeDescription}
                  isValid={true}
                  labelStyles={{ fontWeight: 'bold' }}
                />
              </div>
            </div>
          </div>
        )}

        <div className="input-file-row__field input-file-row__field--remove">
          <div className="input-file-row__value">
            <FontAwesomeIcon
              onClick={handleRemove}
              icon={faTimes}
              color="#f40"
              size="lg"
              className="input-file-row__remove-btn"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

InputFileRow.propTypes = {
  value: PropTypes.shape({
    file: PropTypes.object.isRequired,
    description: PropTypes.string,
  }),
  isValid: PropTypes.bool,
  index: PropTypes.number.isRequired,
  onChange: PropTypes.func,
  onRemove: PropTypes.func,
};

export default InputFileRow;
